<header class="hero-unit small chrome-no-repaint" id="banner">
  <div class="container">
    <div class="box-marked no-bg dark-text">
      <br />
      <br />
      <h1>Topics</h1>
      <br />
      <p>
        Click on any topic below and see all existing projects
        <br />
        or create new projects for that topic.
      </p>
      <ng-content></ng-content>
    </div>
  </div>
  <div class="background-image-wrapper">
    <div class="background-image no-blur"></div>
  </div>
</header>
